import type { PickersShortcutsItem } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const useShortcut = () => {
  const { t } = useTranslation("core.shortcuts");

  const singleShortcuts: PickersShortcutsItem<any>[] = [
    {
      label: t("single.start_of_month"),
      getValue: () => {
        return dayjs(new Date()).startOf("month");
      },
    },
    {
      label: t("single.15_of_month"),
      getValue: () => {
        return dayjs(new Date()).date(15);
      },
    },
    {
      label: t("single.end_of_month"),
      getValue: () => {
        return dayjs(new Date()).endOf("month");
      },
    },
    {
      label: t("single.start_of_week"),
      getValue: () => {
        return dayjs(new Date()).startOf("week");
      },
    },
    {
      label: t("single.end_of_week"),
      getValue: () => {
        return dayjs(new Date()).endOf("week");
      },
    },
    {
      label: t("single.yesterday"),
      getValue: () => {
        return dayjs(new Date()).subtract(1, "day");
      },
    },
    {
      label: t("single.today"),
      getValue: () => {
        return dayjs(new Date());
      },
    },
    {
      label: t("single.tomorrow"),
      getValue: () => {
        return dayjs(new Date()).add(1, "day");
      },
    },
  ];

  const rangeShortcuts: PickersShortcutsItem<any>[] = [
    {
      label: t("range.last_week"),
      getValue: () => {
        return [
          dayjs(new Date()).subtract(6, "day").startOf("week"),
          dayjs(new Date()).subtract(6, "day").endOf("week"),
        ];
      },
    },
    {
      label: t("range.current_week"),
      getValue: () => {
        return [
          dayjs(new Date()).startOf("week"),
          dayjs(new Date()).endOf("week"),
        ];
      },
    },
    {
      label: t("range.next_week"),
      getValue: () => {
        return [
          dayjs(new Date()).add(6, "day").startOf("week"),
          dayjs(new Date()).add(6, "day").endOf("week"),
        ];
      },
    },
    {
      label: t("range.yesterday"),
      getValue: () => {
        return [
          dayjs(new Date()).subtract(1, "day"),
          dayjs(new Date()).subtract(1, "day"),
        ];
      },
    },
    {
      label: t("range.today"),
      getValue: () => {
        return [dayjs(new Date()), dayjs(new Date())];
      },
    },
    {
      label: t("range.tomorrow"),
      getValue: () => {
        return [
          dayjs(new Date()).add(1, "day"),
          dayjs(new Date()).add(1, "day"),
        ];
      },
    },
    {
      label: t("range.yesterday_today_tomorrow"),
      getValue: () => {
        return [
          dayjs(new Date()).subtract(1, "day"),
          dayjs(new Date()).add(1, "day"),
        ];
      },
    },
    {
      label: t("range.last_7_days"),
      getValue: () => {
        return [dayjs(new Date()).subtract(6, "day"), dayjs(new Date())];
      },
    },
    {
      label: t("range.last_30_days"),
      getValue: () => {
        return [dayjs(new Date()).subtract(29, "day"), dayjs(new Date())];
      },
    },
    {
      label: t("range.next_30_days"),
      getValue: () => {
        return [
          dayjs(new Date()).add(1, "day"),
          dayjs(new Date()).add(30, "day"),
        ];
      },
    },
    {
      label: t("range.current_month"),
      getValue: () => {
        return [
          dayjs(new Date()).startOf("month"),
          dayjs(new Date()).endOf("month"),
        ];
      },
    },
  ];

  const dateFormat = t("format.date");
  const dateTimeFormat = t("format.date_time");

  return {
    singleShortcuts,
    rangeShortcuts,
    dateFormat,
    dateTimeFormat,
  };
};

export { useShortcut };
